<template>
  <PreviewSheet border="secondary" class="cards-card" radius="large">
    <div class="cards-card__body flex-col gap-4">
      <div
        v-if="card.image"
        class="cards-card__image"
        :style="{ backgroundImage: `url(${card.image})` }"
      ></div>
      <div class="flex-col gap-2">
        <PreviewTypographyLegacy :text="card.title" variant="titleLarge" />
        <PreviewTypographyLegacy
          v-if="card.subtitle"
          :text="card.subtitle"
          variant="paragraphRegular"
        />
      </div>
      <PreviewTypographyLegacy
        v-if="card.description"
        :text="card.description"
        variant="paragraphSmall"
      />
      <PreviewButton v-if="card.buttonLabel" :title="card.buttonLabel" />
    </div>
  </PreviewSheet>
</template>

<script lang="ts" setup>
import PreviewTypographyLegacy from '@/lib/builder/public/preview/legacy/PreviewTypographyLegacy.vue'
import PreviewButton from '@/lib/builder/public/preview/PreviewButton.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'

import { type CardsSection } from '../../../WebsiteBuilder.types'

defineProps<{
  card: CardsSection['params']['cards'][number]
}>()
</script>

<style lang="scss" scoped>
.cards-card {
  padding: 16px;
  text-align: left;
  width: 100%;

  &__body {
    height: 100%;
  }

  &__image {
    width: 100%;
    padding-top: 56%;
    background-size: cover;
    background-position: center;
    border-radius: 12px;
  }
}
</style>
